module.exports = __webpack_public_path__ + "media/ui-reward-sale.870f558b.mp3";